import React from "react";
import line from "../assets/line.png";
import SolutionSection from "../pages/SolutionSection";
import { motion } from "framer-motion";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Product = () => {
  return (
    <div className="min-h-screen scroll-smooth">

      {/* ===========================
          HERO SECTION (1024×850)
      ============================ */}
   <section className="relative h-[50vh] sm:h-[60vh] flex items-center justify-center text-white overflow-hidden">

  {/* Video always covers properly */}
  <video
    className="
      absolute top-0 left-0 w-full h-full z-0
      object-cover
    "
    src="/Product780.mp4"
    autoPlay
    muted
    loop
    playsInline
  />

  {/* Overlay */}
  <div className="absolute inset-0 bg-black/40 z-10" />

  {/* Content */}
  <div className="
      relative z-20 max-w-6xl w-full mx-auto h-full 
      flex flex-col justify-center items-center 
      px-4 sm:px-6 md:px-8 pt-10
    "
  >
    <motion.h1
      className="text-3xl sm:text-5xl md:text-7xl font-bold uppercase text-center"
      initial={{ opacity: 0, y: -40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      EXPLORE WISE
    </motion.h1>

    <motion.h2
      className="
        uppercase font-extrabold text-transparent 
        text-center mt-2 sm:mt-4
      "
      style={{
        fontFamily: 'Calibri, sans-serif',
        WebkitTextStroke: '1.5px #ffffff',
        lineHeight: '1.2',
      }}
      initial={{ opacity: 0, x: -70 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 1.2 }}
    >
      <span
  className="
    text-2xl sm:text-4xl md:text-6xl lg:text-[5rem] leading-tight
    text-white [@media(hover:hover)]:text-transparent
  "
  style={{
    WebkitTextStroke: '1.5px #ffffff',
  }}
>
  OUR AI POWERED PRODUCTS
</span>
    </motion.h2>
  </div>
</section>



      {/* ===========================
          PRODUCT DESCRIPTION (1024×612)
      ============================ */}
      {/* ===========================
    PRODUCT DESCRIPTION (1024×580 FIXED)
============================ */}
<section className="
  snap-start 
  w-[1024px] h-[580px] 
  md:w-auto md:h-auto
  bg-white
  flex flex-col justify-start items-center text-center
  pt-[120px] pb-12 px-4 sm:px-6 lg:px-8
">
  <div className="max-w-6xl w-full mx-auto flex flex-col items-center 
                  text-gray-900 text-sm sm:text-base md:text-lg lg:text-xl 
                  leading-relaxed space-y-6 sm:space-y-10">

   <p className="max-w-4xl text-center px-2 sm:px-4 text-[26px] leading-[1.5]">
  WISE offers a suite of platform-based products designed to
  revolutionize Healthcare, Lifesciences and other domains.
  Our AI-driven solutions provide seamless integration,
  enhanced efficiency, and data-driven decision-making.
</p>



    <div className="w-full">
      <SolutionSection />
    </div>

  </div>
</section>


      {/* ===========================
          BENEFITS (1024×580)
      ============================ */}
      <section className=" bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white flex items-center justify-center snap-start w-full !h-auto py-16 sm:py-20 lg:py-[120px]">
        <div className="max-w-6xl w-full px-4 sm:px-6 lg:px-8 flex flex-col">
          {/* Heading (Left Aligned) */}
        <div className="relative inline-block mobile-desktopsite-shift">
  <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold">
    Benefits of <span style={{ color: "#0077cc" }}>Wise</span> Products
  </h2>

  <img
    src={line}
    alt="underline"
    className="absolute -bottom-2 h-[4px] sm:h-[6px] object-contain"
  />
</div>


          <div className="mt-12 sm:mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 w-full max-w-3xl sm:max-w-4xl mx-auto justify-center">
  <ul className="max-[1024px]:pl-14 pl-0 space-y-4 sm:space-y-6 list-disc list-inside marker:text-blue-400 text-base sm:text-lg md:text-[26px] leading-relaxed">
    {["Enhanced Efficiency", "Seamless Integration", "Optimized Workflow"].map((item, i) => (
      <li key={i} className="font-medium hover:translate-x-2 transition-transform">{item}</li>
    ))}
  </ul>

  <ul className="space-y-4 sm:space-y-6 list-disc list-inside marker:text-blue-400 text-base sm:text-lg md:text-[26px] leading-relaxed">
    {["Data Driven Precision", "Scalability & Flexibility", "Regulatory Compliance"].map((item, i) => (
      <li key={i} className="font-medium hover:translate-x-2 transition-transform">{item}</li>
    ))}
  </ul>
</div>

        </div>
      </section>

      {/* ===========================
          FOOTER (unchanged)
      ============================ */}
      <section className="
        relative 
        bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F]
        overflow-hidden h-auto
      ">
        <div className="absolute top-[180px] left-0 w-full">
          <div className="bg-white rounded-t-[12rem] sm:rounded-t-[14rem] h-auto sm:h-[120vh] pb-10"></div>
        </div>

        <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
          <div className="text-center mt-[160px] mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]">Collaborate for Success</h2>
            <p className="text-gray-700 text-lg sm:text-xl font-medium">
              Working together fosters innovation, creativity, and a greater sense of accomplishment.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">

            <div>
              <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
              <img src={ColourLogo} alt="Wissenstil" className="w-40 mb-4" />
              <p>Wissenstil Solutions drives digital innovation.</p>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
              <ul className="space-y-2">
                <li>Image Analysis</li>
                <li>Anomaly Detection</li>
                <li>Medical Coding</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
              <ul className="space-y-2">
                <li><Link to="/about" className="hover:text-purple-700">About Us</Link></li>
                <li><Link to="/services" className="hover:text-purple-700">Wise Services</Link></li>
                <li><Link to="/products" className="hover:text-purple-700">Wise Products</Link></li>
                <li><Link to="/contact" className="hover:text-purple-700">Contact Us</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
              <p>
                Wissenstil Solutions Pvt Ltd<br />
                Whitefield, Bangalore
              </p>
              <div className="mt-4 space-y-3">
                <p className="flex items-center gap-2"><Phone /> +91 9986158307</p>
                <p className="flex items-center gap-2"><Mail /> Manish.palliyil@wissenstil.com</p>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Product;